<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    @onApproval="rejected"
    @onReject="onReject"
    :isConfirm="isConfirm"
    :isReject="isReject"
    :confirmName="confirmName"
    :width="width"
    :class="{ hideButton: isHide }"
  >
    <div slot="content">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane
          label="基本信息"
          name="base"
          style="max-height: 60vh; overflow-y: auto; overflow-x: hidden"
        >
          <slot name="content"></slot>
        </el-tab-pane>
        <el-tab-pane label="审核意见" name="opinion">
          <div style="padding-left: 30px">
            <h4 style="margin-bottom: 20px; font-weight: bold">审核进程：</h4>
            <div style="height: 300px; padding-left: 60px">
              <el-steps direction="vertical" :active="activeIndex">
                <el-step
                  :title="step.StepName"
                  v-for="(step, index) in stepList"
                  :key="index"
                >
                  <template slot="description">
                    <span v-if="step.FinishTime"
                      >{{ (step.FinishTime * 1000) | formatDate }}<br />{{
                        step.PartName
                      }}<br />{{ step.ApprovalOpinions }}</span
                    >
                    <span v-else>{{ step.PartName }}</span>
                  </template>
                </el-step>
              </el-steps>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <ModelOpinion
        :dataForm="request"
        v-if="opinionVisible"
        :isTrain="isTrain"
        :isRejected="isRejected"
        @formCallBack="opinionCallBack"
        @onConfirm="approvalConfirm"
      ></ModelOpinion>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog_approval";
import ModelOpinion from "@/modules/zjrc/pages/workbench/common/opinion";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    formTitle: {
      type: String,
      default: "",
    },
    confirmName: {
      type: String,
      default: "通过",
    },
    width: {
      type: String,
      default: "68%",
    },
    backlogModel: {
      type: Object,
      default: null,
    },
    isHide: {
      type: Boolean,
      default: false,
    },
    isTrain: {
      type: Boolean,
      default: false
    },
    isReject: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      activeName: "base", //激活的选项卡
      activeIndex: 1, //审核意见激活步骤
      stepList: [], //审核步骤数组
      opinionVisible: false,
      request: {}, //
      isConfirm: false,
      isRejected: false
    };
  },
  components: {
    OfDialog,
    ModelOpinion,
  },
  computed: {},
  mounted() {
    let that = this;
    that.getStepList();
  },
  methods: {
    onReject() {
      let that = this;
      that.isConfirm = true;
      that.request = Object.assign({}, that.backlogModel);
      that.request.ApprovalOpinions = "已退回，无意见。";
      that.request.ApprovalStatus = 5;
      that.isRejected = true
      that.opinionVisible = true;
    },
    //取消
    cancel() {
      this.$emit("cancelCallBack", false);
    },
    //提交
    confirm() {
      let that = this;
      that.isConfirm = true;
      that.request = Object.assign({}, that.backlogModel);
      that.request.ApprovalOpinions = "已审核，无意见。";
      that.request.ApprovalStatus = 2;
      that.isRejected = false
      that.opinionVisible = true;
    },
    //驳回
    rejected() {
      let that = this;
      that.isConfirm = true;
      that.request = Object.assign({}, that.backlogModel);
      that.request.ApprovalOpinions = "申请不符合要求，退回。";
      that.request.ApprovalStatus = 4;
      that.isRejected = true
      that.opinionVisible = true;
    },
    //审批意见窗口取消按钮回调
    opinionCallBack(data) {
      let that = this;
      that.opinionVisible = false;
      that.isConfirm = false;
    },
    approvalConfirm(data) {
      this.$emit("approvalConfirm", data);
    },
    //审核步骤
    getStepList() {
      let that = this;
      let params = { Id: that.backlogModel.CurrentStepId };
      api.QueryApprovalStepById(params).then((res) => {
        if (res.data.Code === 0) {
          var stepList = res.data.Data;
        }
        that.getApprovalStep(stepList);
      });
    },
    //审核记录
    getApprovalStep(stepList) {
      let that = this;
      let params = { Id: that.backlogModel.Id };
      api.QueryApprovalLogByProcId(params).then((res) => {
        if (res.data.Code === 0) {
          let approvalStep = res.data.Data;
          stepList.find((item, index) => {
            approvalStep.forEach((element) => {
              if (
                element.CurrentStepId == item.Id &&
                element.ApprovalOpinions != null
              ) {
                item.FinishTime = element.FinishTime;
                item.ApprovalOpinions = element.ApprovalOpinions;
                that.activeIndex = index + 3;
              }else{
                that.activeIndex = index + 2;
              }
            });
          });
        }
        stepList.splice(0, 0, {
          StepName: "发起",
          PartName: that.backlogModel.Creator,
          FinishTime: that.backlogModel.StartTime,
          PartComment: "",
        });
        stepList.push({ StepName: "结束" });
        that.stepList = stepList;
      });
    },
  },
};
</script>
<style >
.hideButton .el-button--warning {
  display: none;
}

.hideButton .el-button--primary {
  display: none;
}
</style>